import { Outlet, useNavigate } from "react-router-dom";
import { useCheckTokenQuery } from "../features/CallApi";
import { useEffect } from "react";
import classes from './FullScreenLayout.module.css';


export const FullScreenLayout = () => {
    
    const { isLoading, isError, error } = useCheckTokenQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (isError) {
            if (error.status == 401) {
                sessionStorage.setItem("returnUrl", window.location.pathname)
                navigate('/login')
            }
        }
        // document.getElementsByTagName("body").
        document.body.classList.add("queuebody")
    }, [isLoading]
    );

    return (
        <Outlet />
    )
}